import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TIPO_FICHERO } from "api/Types/TipoFichero"
import NativePDFViewer from "common/components/NativePDF/NativePDF"
import { useEffect, useState } from "react"
import Dropzone from "react-dropzone"
import { Trans, useTranslation } from "react-i18next"
import { convertirPDFaBase64, encodeImageToBase64 } from "utils/encodeBase64"
import subirDocumentoNube from "../../../../../../../../assets/subirDocumentoNube.svg"
import {
  ErrorsTicketsFormProps,
  InsertTicketProps,
  TouchedTicketsFormProps,
} from "../FormTicketNew"
import { getFileType } from "../FormTicketNew/constant"

interface DropZoneTicketsProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setFieldValue: (arg: string, value: $TSMigrationFixMe) => void
  values: InsertTicketProps
  errors: ErrorsTicketsFormProps
  touched: TouchedTicketsFormProps
  isMobile: boolean
  imageData: string
  setImageData: React.Dispatch<React.SetStateAction<string>>
}

const DropZoneTickets = ({
  setFieldValue,
  values,
  touched,
  errors,
  isMobile,
  imageData,
  setImageData,
}: DropZoneTicketsProps) => {
  const { t } = useTranslation()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [ticketFile, setTicketFile] = useState<any>(values.fichero ?? null)

  const handleUploadFacturas = async (acceptedFiles: Blob[]) => {
    const type = getFileType(acceptedFiles[0]?.type)
    if (type === TIPO_FICHERO.IMAGEN) {
      const encodedFileAsBase64 = await encodeImageToBase64(acceptedFiles[0])
      setFieldValue("ficheroType", type)
      setFieldValue("fichero", encodedFileAsBase64.split(",")[1])
      setTicketFile(encodedFileAsBase64)
      setImageData(encodedFileAsBase64)
    } else if (type === TIPO_FICHERO.PDF) {
      setFieldValue("fichero", await convertirPDFaBase64(acceptedFiles[0]))
      setFieldValue("ficheroType", type)
      setTicketFile(acceptedFiles[0])
    }
  }

  useEffect(() => {
    const processImageData = async () => {
      try {
        const response = await fetch(imageData)
        const blob = await response.blob()
        const base64data = await encodeImageToBase64(blob)

        setTicketFile(base64data)
        setFieldValue("fichero", base64data.split(",")[1])
        setFieldValue("ficheroType", TIPO_FICHERO.IMAGEN)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error processing image data:", error)
      }
    }

    if (isMobile && imageData) {
      processImageData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, imageData])

  return (
    <div className='tw-h-full'>
      <div className='tw-h-full'>
        <div
          className={`tw-flex tw-flex-col tw-h-full tw-p-4 tw-bg-simple-10 tw-rounded tw-shadow ${
            touched?.fichero && errors?.fichero
              ? "tw-border-danger tw-border"
              : ""
          }`}
        >
          <Dropzone
            maxSize={4097152}
            accept={["image/*", "application/pdf"]}
            onDrop={handleUploadFacturas}
            noClick
            noKeyboard
          >
            {({ getRootProps, getInputProps, open }) => (
              <section className='tw-w-full tw-h-full'>
                <div
                  {...getRootProps({ className: "dropzone" })}
                  className='tw-w-full tw-h-full tw-cursor-default'
                >
                  <div className='tw-flex tw-flex-col tw-justify-center tw-h-full tw-w-full !tw-cursor-default'>
                    {values.ficheroType === TIPO_FICHERO.PDF && (
                      <div
                        className='hover:!tw-shadow !tw-cursor-pointer tw-h-10 tw-mb-4 tw-px-4 tw-border-danger tw-text-danger tw-border tw-rounded tw-flex tw-justify-center tw-items-center'
                        onClick={() => {
                          setTicketFile(null)
                          setFieldValue("ficheroType", null)
                          setFieldValue("fichero", null)
                        }}
                      >
                        {t("tickets.dropzone.deletePdf")}
                      </div>
                    )}
                    <input
                      className='tw-hidden tw-cursor-default'
                      {...getInputProps()}
                    />
                    {ticketFile ? (
                      <div className='tw-bg-slate-500 tw-relative tw-flex tw-justify-center tw-items-center tw-w-full tw-h-full tw-m-0 tw-cursor-default'>
                        {values.ficheroType === TIPO_FICHERO.IMAGEN ? (
                          <img
                            alt={`${t("tickets.labelImg")}`}
                            src={ticketFile}
                            width='500'
                            className='tw-w-auto tw-h-auto tw-max-h-full tw-max-w-full tw-py-20 tw-px-10 tw-object-cover tw-object-center'
                          />
                        ) : (
                          <NativePDFViewer
                            pdf={ticketFile}
                            type='stream'
                          />
                        )}
                        {values.ficheroType === TIPO_FICHERO.IMAGEN && (
                          <div className='tw-absolute tw-top-0 tw-right-0 tw-w-full tw-h-full tw-rounded hover:!tw-opacity-100 tw-opacity-0'>
                            <div className='tw-relative tw-w-full tw-h-full'>
                              <div className='tw-absolute tw-top-0 tw-right-0 tw-p-6 tw-w-full tw-h-full tw-flex tw-justify-cemter tw-items-center tw-opacity-40 tw-bg-simple-90' />
                              <div className='tw-absolute tw-top-0 tw-right-0 tw-p-6 tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-start tw-items-end'>
                                <div
                                  className='tw-bg-danger tw-w-12 tw-h-12 tw-rounded tw-flex tw-items-center tw-justify-center tw-cursor-pointer'
                                  onClick={() => {
                                    setTicketFile(null)
                                    setFieldValue("ficheroType", null)
                                    setFieldValue("fichero", null)
                                    setImageData("")
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={["fal", "x"]}
                                    className='tw-w-3 tw-h-5 tw-text-simple-10'
                                  />
                                </div>
                                <div className='tw-w-full tw-h-full tw-mb-12 tw-flex tw-justify-center tw-items-center'>
                                  <div
                                    onClick={open}
                                    className=' tw-cursor-pointer tw-bg-transparent tw-w-32 tw-h-12 tw-flex tw-justify-center tw-items-center tw-text-simple-10 tw-border tw-border-simple-10 tw-rounded'
                                  >
                                    {t("tickets.dropzone.cambiarLabel")}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className='tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-p-8 tw-cursor-default'>
                        <img
                          className='tw-h-32 tw-w-40 tw-mb-6'
                          src={subirDocumentoNube}
                          alt='Bicolor.svg'
                        />
                        <div className='tw-flex tw-flex-col tw-w-[444px] tw-items-center'>
                          <p className='tw-w-full tw-font-medium tw-text-2xl tw-text-center tw-mb-3'>
                            {t("tickets.dropzone.addImgLabel")}
                          </p>
                          <p className='tw-w-56 tw-mb-4'>
                            <Trans
                              i18nKey='tickets.dropzone.arrastraLabel'
                              components={[
                                <span
                                  className='tw-text-info-100 tw-cursor-pointer'
                                  key='0'
                                  onClick={open}
                                />,
                              ]}
                            />
                          </p>
                          <div
                            className='tw-cursor-pointer tw-w-36 tw-h-10 tw-text-simple-10 tw-bg-primary tw-rounded tw-flex tw-justify-center tw-items-center'
                            onClick={open}
                          >
                            {t("tickets.dropzone.searchImgLabel")}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </section>
            )}
          </Dropzone>
        </div>
      </div>
    </div>
  )
}

export default DropZoneTickets
